import { AccountDetailsInit } from '../../account';
import { ContactForm } from '../../contact-form';

declare interface podiumWindow extends Window {
    PodiumWebChat?: { open: () => void };
}
declare const window: podiumWindow;

// Staffed weekdays, in the hours the site publishes. A chat launcher that opens
// onto an empty room is worse than one that says where to go instead, and the
// day rolls over while a page is left open, so the card re-checks on a timer.
const staffedDays = [1, 2, 3, 4, 5];
const staffedFromHour = 9;
const staffedToHour = 18;
const staffedZone = 'America/New_York';
const recheckMs = 60_000;

function staffedNow(): boolean {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: staffedZone,
        weekday: 'short',
        hour: 'numeric',
        hour12: false,
    }).formatToParts(new Date());

    const weekday = parts.find(p => p.type === 'weekday')?.value ?? '';
    const hour = Number(parts.find(p => p.type === 'hour')?.value ?? NaN);
    const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(weekday);

    if (!staffedDays.includes(day) || Number.isNaN(hour)) {
        return false;
    }
    return hour >= staffedFromHour && hour < staffedToHour;
}

void main();

async function main() {
    await AccountDetailsInit();

    const $form = document.querySelector('#contact-form') as HTMLFormElement;
    const $formTemplate = document.querySelector('#contact-form-template') as HTMLTemplateElement;
    ContactForm($form, $formTemplate);

    const $chatOpenBody = document.querySelector('#help-chat-open-body') as HTMLElement;
    const $chatClosedBody = document.querySelector('#help-chat-closed-body') as HTMLElement;
    const $chatOpen = document.querySelector('#help-chat-open') as HTMLButtonElement;

    const renderChat = () => {
        const staffed = staffedNow();
        $chatOpenBody.classList.toggle('d-none', !staffed);
        $chatClosedBody.classList.toggle('d-none', staffed);
        $chatOpen.disabled = !staffed;
    };

    renderChat();
    window.setInterval(renderChat, recheckMs);

    $chatOpen.addEventListener('click', () => {
        window.PodiumWebChat?.open();
    });
}
